import TeamDetailTabs from '@/components/teams/TeamDetailTabs'

// Mock team data for testing
const mockTeam = {
  id: 1,
  uuid: 'test-team-uuid-123',
  name: 'Frontend Development Team',
  description: 'Responsible for all frontend development and user experience',
  team_type: 'recruiting',
  max_members: 10,
  member_count: 5,
  is_active: true,
  created_at: '2024-01-15T10:00:00Z',
  team_lead: {
    id: 1,
    name: 'John Smith',
    email: 'john.smith@company.com'
  }
}

export default function TestTeamPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-6">
            <div className="flex items-center space-x-4">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">{mockTeam.name}</h1>
                <p className="text-sm text-gray-500">{mockTeam.description}</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <span className="px-3 py-1 text-sm font-medium rounded-full bg-blue-100 text-blue-800">
                {mockTeam.team_type}
              </span>
              <span className="px-3 py-1 text-sm font-medium rounded-full bg-green-100 text-green-800">
                Active
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TeamDetailTabs teamId="test-team-123" team={mockTeam} />
      </div>
    </div>
  )
}